"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompose = exports.ComposeProvider = void 0;
const react_1 = require("react");
const ComposeContext = (0, react_1.createContext)(undefined);
const ComposeProvider = ComposeContext.Provider;
exports.ComposeProvider = ComposeProvider;
// We want to check that any component using useCompose is wrapped by a <Compose> (aka the Provider is present)
// N.B. The context won't update from undefined until on the client-side
// so we add a check here to only throw an error if the Provider isn't supplied
// properly if we're on client-side, and to return default values if we're server-side
const useCompose = () => {
    const context = (0, react_1.useContext)(ComposeContext);
    if (typeof window !== "undefined") {
        if (context === undefined) {
            throw new Error("This component is a ComposeConsumer, it must be used within a ComposeProvider");
        }
        return context;
    }
    return {
        maxFiles: 0,
        maxAllowedFileSize: { size: 0, humanReadable: "0" },
        allowedFileExtensions: [],
        canCompose: true,
        canSend: true,
        isSending: false,
        uploadedFiles: [],
        isUploadingFile: false,
        uploadingFileErrors: [],
    };
};
exports.useCompose = useCompose;
//# sourceMappingURL=ComposeContext.js.map